import { KIOSK_COMMUNICATION_EVENT_TYPES } from "../../../../util/communication_statuses";

export const getEventName = (event, t) => {
  switch (event.type) {
    case KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_OPENED:
      return t("cc_opened").message || "Opened";
    case KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_ANSWERED:
      return t("cc_answered").message || "Answered";
    case KIOSK_COMMUNICATION_EVENT_TYPES.LABEL_DETACHED:
      return t("cc_kiosk_key_label_detached").message || "Kiosk key label detached";
    default:
      return "";
  }
};
